import { RootState, useAppSelector } from '..';

export const selectRegistration = (state: RootState) => state.registration.data;
export const useRegistration = () => useAppSelector(selectRegistration);
